import React, { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Button,
  Card,
  CardBody,
  CardText,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
} from "reactstrap"

import BasicInfoTab from "./tabs/BasicInfoTab"
import { getNotificationDetail as onGetNotificationDetail } from "store/actions"
import { isEmpty } from "lodash"
import EmptyContainer from "components/Common/EmptyContainer"
import { useDeepCompareEffect } from "hooks"

const NotificationAddEdit = () => {
  const navigate = useNavigate()
  const routeParams = useParams()
  const dispatch = useDispatch()
  const [header, setHeader] = useState("")
  const [tabValue, setTabValue] = useState("1")
  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title ="Notifications | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  useDeepCompareEffect(() => {
    const { id } = routeParams

    if (id === "new") {
      setHeader("Add Notification")
    } else {
      setHeader("Edit Notification")
      dispatch(onGetNotificationDetail(id))
    }
  }, [dispatch, routeParams])

  //////////////////Notification STATE/////////////////////
  const data = useSelector(state => state.notification)

  const toggleTab = tab => {
    if (tabValue !== tab) {
      setTabValue(tab)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Notification" breadcrumbItem={header} />
          {routeParams.id !== "new" && isEmpty(data.notification) ? (
            <EmptyContainer
              backURL="/notifications"
              message="There is no such notification!"
              linkText="Go to Notifications Page"
            />
          ) : (
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <CardTitle>Basic Information</CardTitle>
                    <p className="card-title-desc mb-4">
                      Fill all information below
                    </p>
                    <Row>
                      <Col sm="12">
                        <BasicInfoTab />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default NotificationAddEdit
